import script from "./SelectDefaultCom.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDefaultCom.vue?vue&type=script&setup=true&lang=js"

import "./SelectDefaultCom.vue?vue&type=style&index=0&id=128ef303&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128ef303"]])

export default __exports__